var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"app":"","color":"white"}},[_c('img',{attrs:{"src":require("./assets/ex_logo.png"),"alt":"Exemplar Logo"}}),_c('Nav',{staticClass:"nav"})],1),_c('v-content',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }